<template>
  <router-view />
  <PassWord
    :visible="forcePwdVisible"
    :force="true"
    @close="onForcePwdClose"
    @success="onForcePwdSuccess"
  />
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import PassWord from '@/views/User/PassWord.vue'
import { getCurrentTimestamp } from '@/utils/solt/timestamp'
import { sortByMd5WithSalt } from '@/utils/solt'
import { getUserInfo } from '@/api/user'

const route = useRoute()
const forcePwdVisible = ref(false)
let checking = false

const syncForcePasswordFlag = (mustChange: boolean) => {
  try {
    const userInfo = JSON.parse(localStorage.getItem('UserInfo') || '{}')
    userInfo.must_change_password = mustChange ? 1 : 0
    localStorage.setItem('UserInfo', JSON.stringify(userInfo))
  } catch (e) {}
  forcePwdVisible.value = mustChange
}

/** 刷新/进入业务页时，请求后端核对密码是否仍为 123456 */
const checkForceChangePassword = async () => {
  if (checking) return
  const token = localStorage.getItem('token')
  if (!token) {
    forcePwdVisible.value = false
    return
  }
  // 公开页 / 登录页不弹强制改密
  if (route.meta?.public || route.path === '/login' || route.name === 'login') return

  // 先用本地缓存快速弹出，再以后端结果为准
  try {
    const cached = JSON.parse(localStorage.getItem('UserInfo') || '{}')
    if (cached?.must_change_password == 1) {
      forcePwdVisible.value = true
    }
  } catch (e) {}

  checking = true
  try {
    const time = await getCurrentTimestamp()
    const obj = { timestamp: time }
    const sign = await sortByMd5WithSalt(obj)
    const res: any = await getUserInfo({ timestamp: time, sign })
    const user = res?.data?.user || res?.user
    const codeOk = res?.code == 200 || res?.code === undefined
    if (codeOk && user) {
      const mustChange = user.must_change_password == 1
      syncForcePasswordFlag(mustChange)
    }
  } catch (e) {
    console.error('检查简易密码失败', e)
  } finally {
    checking = false
  }
}

const onForcePwdClose = () => {
  forcePwdVisible.value = false
}

const onForcePwdSuccess = () => {
  syncForcePasswordFlag(false)
}

onMounted(() => {
  checkForceChangePassword()
})

watch(
  () => route.fullPath,
  () => {
    checkForceChangePassword()
  },
)
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  color: #2c3e50;
  background-color: #f0f2f5;
}
html {
  background-color: #f0f2f5;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

/* 公开页需可滚动（覆盖 SiderBar 的 overflow:hidden） */
html.landing-page,
html.landing-page body,
html.landing-page #app {
  background: #ffffff !important;
  height: auto !important;
  min-height: 100%;
  overflow: auto !important;
  overflow-x: hidden !important;
}
</style>
